document.addEventListener("DOMContentLoaded", () => {
    const topSalesSections = document.querySelectorAll(".top-sales-index");

    topSalesSections.forEach((section) => {
        const sliderEl = section.querySelector(".swiperTopSales");
        const nextEl = section.querySelector(".swiper-btn-next");
        const prevEl = section.querySelector(".swiper-btn-prev");

        if (!sliderEl) return;

        const slidesCount = sliderEl.querySelectorAll(".swiper-slide").length;
        if (!slidesCount) return;

        new Swiper(sliderEl, {
            loop: true,
            speed: 500,
            grabCursor: true,
            allowTouchMove: true,
            watchOverflow: true,

            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 12,

            navigation: {
                nextEl,
                prevEl,
            },

            breakpoints: {
                991: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                },
            },
        });
    });
});
